import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import DeviceGridItem from '~/src/components/Equipment/internet/DeviceGridItem';
import { TEST_NAMES_ATTR } from '~/src/features/equipment/pageBlocks/BannerRoutersCardBlock/constants';

export const renderRouterCards = (routers: IEquipment[]) => {
    return routers.map(router => (
        <DeviceGridItem
            key={router.id}
            item={router}
            baseRoute={'/internet/equipment'}
            data-test={TEST_NAMES_ATTR.routerCard}
            isCharacteristics={true}
        />
    ));
};
